export default __webpack_public_path__ + "static/media/img_recipe.31bef29c.png";